/**
 * What the zero measurement start button is showing: the validity of the
 * latest zero measurement (idle), the progress of a running one (measuring),
 * or the outcome of one that just finished (succeeded). Its parts take the
 * phase as a prop and own their looks for each.
 */
export type ZeroMeasurementButtonPhase = 'idle' | 'measuring' | 'succeeded';

// The button is a 68px ring with the 40px pie as its hub. The pie is a circle
// whose stroke is as wide as its radius, so a dash along its circumference
// paints a wedge. The button's SVG and the pie's group share this coordinate
// space; the ring label's arc is derived from the pie radius.
export const BUTTON_SIZE = 68;
export const BUTTON_CENTER = BUTTON_SIZE / 2;
export const PIE_RADIUS = 20;
export const WEDGE_RADIUS = PIE_RADIUS / 2;
export const WEDGE_CIRCUMFERENCE = 2 * Math.PI * WEDGE_RADIUS;
